import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../theme';

// Переключатель канала из макета. Подключён только WhatsApp: Viber требует
// минимум €200/мес и невыгоден на 118 контактов, поэтому показан неактивным,
// а не сделан вид, что он работает. SMS из платформы исключён.
const CHANNELS = [
  { key: 'viber', label: 'Viber', enabled: false, why: 'Viber не подключён: минимум €200/мес' },
  { key: 'whatsapp', label: 'WhatsApp', enabled: true },
];

const useStyles = makeStyles({
  row: {
    display: 'flex',
    borderRadius: 8,
    overflow: 'hidden',
    border: `1px solid ${colors.border}`,
    maxWidth: 430,
  },
  cell: {
    flex: 1,
    padding: '11px 0',
    textAlign: 'center',
    fontSize: '13.5px',
    fontWeight: 600,
    backgroundColor: colors.panel,
    color: colors.textDim,
    borderRight: `1px solid ${colors.border}`,
    '&:last-child': { borderRight: 'none' },
  },
  active: {
    backgroundColor: colors.accent,
    color: '#ffffff',
  },
  disabled: {
    color: colors.textFaint,
    cursor: 'default',
  },
});

function ChannelSwitch() {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      {CHANNELS.map((channel) => {
        if (channel.enabled) {
          return (
            <div
              key={channel.key}
              className={`${classes.cell} ${classes.active}`}
            >
              {channel.label}
            </div>
          );
        }
        return (
          <Tooltip key={channel.key} title={channel.why}>
            <div className={`${classes.cell} ${classes.disabled}`}>
              {channel.label}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}

export default ChannelSwitch;
